/* =========================================================================
   Highland — comportamiento del tema

   Portado del main.js de WordPress. Sin dependencias externas: el carrusel de
   producto lo movía Swiper y aquí lo lleva un transform sobre .swiper-wrapper,
   conservando sus clases para que el CSS portado siga aplicando.

   Las clases de estado (.is-open, .active, .swiper-button-disabled) son las
   que ya espera highland.css.
   ========================================================================= */
(function () {
	'use strict';

	const $  = (sel, ctx) => (ctx || document).querySelector(sel);
	const $$ = (sel, ctx) => Array.from((ctx || document).querySelectorAll(sel));

	/* Raíz de las rutas ("/" o "/en/" en tiendas con varios idiomas); la fija
	 * Shopify en el storefront. */
	const ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

	/* ------------------------------------------------- Menú móvil */
	(function menu() {
		const nav     = $('[data-menu]');
		const toggle  = $('[data-menu-toggle]');
		const close   = $('[data-menu-close]');
		const overlay = $('[data-menu-overlay]');
		if (!nav || !toggle) return;

		const setOpen = (open) => {
			nav.classList.toggle('is-open', open);
			if (overlay) overlay.classList.toggle('is-open', open);
			toggle.setAttribute('aria-expanded', String(open));
			document.body.style.overflow = open ? 'hidden' : '';
			if (open) {
				const first = $('.nav__link', nav);
				if (first) first.focus();
			} else {
				toggle.focus();
			}
		};

		toggle.addEventListener('click', () => setOpen(!nav.classList.contains('is-open')));
		if (close)   close.addEventListener('click', () => setOpen(false));
		if (overlay) overlay.addEventListener('click', () => setOpen(false));

		document.addEventListener('keydown', (e) => {
			if (e.key === 'Escape' && nav.classList.contains('is-open')) setOpen(false);
		});
	})();

	/* ------------------------------------------------- Panel de búsqueda */
	(function search() {
		const panel  = $('[data-search-panel]');
		const toggle = $('[data-search-toggle]');
		const close  = $('[data-search-close]');
		const input  = $('[data-search-input]');
		if (!panel || !toggle) return;

		const setOpen = (open) => {
			// `hidden` se quita antes de animar: con el atributo puesto la
			// transición de altura no llega a ejecutarse.
			if (open) panel.hidden = false;
			requestAnimationFrame(() => panel.classList.toggle('is-open', open));
			toggle.setAttribute('aria-expanded', String(open));
			if (open && input) input.focus();
			if (!open) {
				setTimeout(() => { if (!panel.classList.contains('is-open')) panel.hidden = true; }, 300);
				toggle.focus();
			}
		};

		toggle.addEventListener('click', () => setOpen(!panel.classList.contains('is-open')));
		if (close) close.addEventListener('click', () => setOpen(false));
		document.addEventListener('keydown', (e) => {
			if (e.key === 'Escape' && panel.classList.contains('is-open')) setOpen(false);
		});
	})();

	/* ------------------------------------------------- Acordeones del listado */
	$$('[data-shop-acc]').forEach((block) => {
		const btn = $('[data-shop-acc-toggle]', block);
		if (!btn) return;
		btn.addEventListener('click', () => {
			const open = block.classList.toggle('is-open');
			btn.setAttribute('aria-expanded', String(open));
		});
	});

	/* ------------------------------------------------- Galería de producto */
	$$('[data-gallery]').forEach((gallery) => {
		// Mismo contenedor que usaba Swiper: highland.css ya estiliza sus hijos.
		const track = $('[data-gallery-main] .swiper-wrapper', gallery);
		if (!track) return;

		const slides  = $$('.product-gallery__slide', track);
		const prev    = $('[data-gallery-prev]', gallery);
		const next    = $('[data-gallery-next]', gallery);
		const bullets = $$('[data-gallery-go]', gallery);
		let index = 0;

		const render = () => {
			track.style.transform = `translateX(-${index * 100}%)`;
			bullets.forEach((b, i) =>
				b.classList.toggle('product-gallery__bullet--active', i === index));
			// .swiper-button-disabled es la clase que highland.css ya estiliza
			// para el botón sin recorrido.
			if (prev) prev.classList.toggle('swiper-button-disabled', index === 0);
			if (next) next.classList.toggle('swiper-button-disabled', index >= slides.length - 1);
		};

		const go = (i) => { index = Math.max(0, Math.min(i, slides.length - 1)); render(); };

		if (prev) prev.addEventListener('click', () => go(index - 1));
		if (next) next.addEventListener('click', () => go(index + 1));
		bullets.forEach((b) => b.addEventListener('click', () => go(Number(b.dataset.galleryGo))));

		gallery.addEventListener('keydown', (e) => {
			if (e.key === 'ArrowLeft')  go(index - 1);
			if (e.key === 'ArrowRight') go(index + 1);
		});

		let startX = null;
		track.addEventListener('touchstart', (e) => { startX = e.touches[0].clientX; }, { passive: true });
		track.addEventListener('touchend', (e) => {
			if (startX === null) return;
			const dx = e.changedTouches[0].clientX - startX;
			if (Math.abs(dx) > 40) go(dx < 0 ? index + 1 : index - 1);
			startX = null;
		}, { passive: true });

		render();
	});

	/* ------------------------------------------------- Lightbox de la galería */
	/* Como el single-product.js de WordPress, el visor se crea al hacer clic y se
	 * destruye al cerrar (nunca queda un overlay colgando). Añade navegación entre
	 * todas las imágenes del producto: flechas, teclado y contador. */
	(function lightbox() {
		$$('[data-gallery]').forEach((gallery) => {
			// Todas las fotos ampliables de esta galería, en orden.
			const zooms = $$('.product-gallery__zoom', gallery);
			if (!zooms.length) return;

			const shots = zooms.map((z) => ({
				src: z.getAttribute('href'),
				alt: ($('img', z) && $('img', z).alt) || '',
			}));
			const multi = shots.length > 1;

			const open = (start) => {
				let i = start;

				const bg = document.createElement('div');
				bg.className = 'product-lightbox';
				bg.innerHTML =
					'<button type="button" class="product-lightbox__close" aria-label="Cerrar">×</button>' +
					(multi ? '<button type="button" class="product-lightbox__nav product-lightbox__nav--prev" aria-label="Anterior">' +
						'<svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"><polyline points="15 18 9 12 15 6"/></svg></button>' : '') +
					'<img class="product-lightbox__img" src="' + shots[i].src + '" alt="' + shots[i].alt + '">' +
					(multi ? '<button type="button" class="product-lightbox__nav product-lightbox__nav--next" aria-label="Siguiente">' +
						'<svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"/></svg></button>' +
						'<div class="product-lightbox__count"><span data-lb-current>' + (i + 1) + '</span> / ' + shots.length + '</div>' : '');
				document.body.appendChild(bg);
				document.body.style.overflow = 'hidden';

				const imgEl = $('.product-lightbox__img', bg);
				const curEl = $('[data-lb-current]', bg);

				const show = (n) => {
					i = (n + shots.length) % shots.length;
					imgEl.src = shots[i].src;
					imgEl.alt = shots[i].alt;
					if (curEl) curEl.textContent = i + 1;
				};

				const close = () => {
					bg.remove();
					document.body.style.overflow = '';
					document.removeEventListener('keydown', onKey);
				};
				const onKey = (e) => {
					if (e.key === 'Escape') close();
					else if (multi && e.key === 'ArrowLeft')  show(i - 1);
					else if (multi && e.key === 'ArrowRight') show(i + 1);
				};

				bg.addEventListener('click', (e) => {
					const prev = e.target.closest('.product-lightbox__nav--prev');
					const next = e.target.closest('.product-lightbox__nav--next');
					if (prev) { e.stopPropagation(); show(i - 1); return; }
					if (next) { e.stopPropagation(); show(i + 1); return; }
					// Clic en el fondo o en la X cierra; clic en la imagen no.
					if (e.target === bg || e.target.closest('.product-lightbox__close')) close();
				});
				document.addEventListener('keydown', onKey);
			};

			gallery.addEventListener('click', (e) => {
				const zoom = e.target.closest('.product-gallery__zoom');
				if (!zoom) return;
				e.preventDefault();
				open(zooms.indexOf(zoom));
			});
		});
	})();

	/* ------------------------------------------------- Pestañas del producto */
	$$('[data-tabs]').forEach((wrap) => {
		const tabs   = $$('[data-tab]', wrap);
		const panels = $$('.woocommerce-Tabs-panel', wrap);
		if (tabs.length < 2) return;

		tabs.forEach((tab) => {
			tab.addEventListener('click', (e) => {
				e.preventDefault();
				const id = tab.getAttribute('href').slice(1);

				tabs.forEach((t) => {
					const on = t === tab;
					t.setAttribute('aria-selected', String(on));
					t.parentElement.classList.toggle('active', on);
				});
				panels.forEach((p) => { p.hidden = p.id !== id; });
			});
		});
	});

	/* ------------------------------------------------- Selector de cantidad */
	$$('[data-qty]').forEach((btn) => {
		btn.addEventListener('click', () => {
			const wrap  = btn.closest('.qty-input');
			const input = wrap && $('.qty-input__num, input[type="number"]', wrap);
			if (!input) return;
			const delta = btn.dataset.qty === 'minus' ? -1 : 1;
			const min   = Number(input.min || 0);
			input.value = Math.max(min, Number(input.value || 0) + delta);
			input.dispatchEvent(new Event('change', { bubbles: true }));
		});
	});

	/* ------------------------------------------------- Variantes */
	(function variants() {
		const form = $('#product-form');
		const data = $('[data-variant-data]');
		if (!form || !data) return;

		let variants;
		try { variants = JSON.parse(data.textContent); } catch { return; }

		const selects = $$('[data-option-select]', form);
		const idField = $('[data-variant-id]', form);
		const submit  = form.querySelector('button[name="add"]');
		const priceEl = $('[data-price]');
		if (!selects.length || !idField) return;

		const money = (cents) =>
			new Intl.NumberFormat(document.documentElement.lang || 'es', {
				style: 'currency',
				currency: window.Shopify && window.Shopify.currency ? window.Shopify.currency.active : 'EUR',
			}).format(cents / 100);

		const update = () => {
			const chosen = selects.map((s) => s.value);
			const match = variants.find((v) => chosen.every((val, i) => v.options[i] === val));

			if (!match) { if (submit) submit.disabled = true; return; }

			idField.value = match.id;
			if (submit) submit.disabled = !match.available;
			if (priceEl) {
				priceEl.innerHTML = match.compare_at_price && match.compare_at_price > match.price
					? `<del>${money(match.compare_at_price)}</del> <ins>${money(match.price)}</ins>`
					: `<span class="price__now">${money(match.price)}</span>`;
			}
		};

		selects.forEach((s) => s.addEventListener('change', update));
		update();
	})();

	/* ------------------------------------------------- Cajón de la cesta (tique) */
	/* Portado de notices.js (WordPress). El cajón lo pinta la sección estática
	 * cart-drawer; tras cada cambio se vuelve a pedir con la Section Rendering
	 * API y se sustituye el tique entero, así el markup sale siempre de Liquid
	 * y no hay una segunda plantilla en JS que mantener. */
	const cartDrawer = (function () {
		const root = () => $('[data-cart-modal]');
		let lockY = 0;

		/* Bloqueo del scroll del fondo conservando la posición, como en WP. */
		const lock = () => {
			lockY = window.scrollY || 0;
			const b = document.body;
			b.style.position = 'fixed';
			b.style.top = `-${lockY}px`;
			b.style.left = '0';
			b.style.right = '0';
			b.style.width = '100%';
			b.classList.add('has-cart-modal');
		};
		const unlock = () => {
			const b = document.body;
			['position', 'top', 'left', 'right', 'width'].forEach((p) => { b.style[p] = ''; });
			b.classList.remove('has-cart-modal');
			window.scrollTo(0, lockY);
		};

		const open = () => {
			const m = root();
			if (!m || m.getAttribute('aria-hidden') === 'false') return;
			m.setAttribute('aria-hidden', 'false');
			lock();
			const panel = $('.cart-modal__panel', m);
			if (panel) panel.scrollTop = 0;
			const first = $('[data-cart-close], a, button', m);
			if (first) first.focus({ preventScroll: true });
		};
		const close = () => {
			const m = root();
			if (!m || m.getAttribute('aria-hidden') === 'true') return;
			m.setAttribute('aria-hidden', 'true');
			unlock();
		};

		const setCount = (n) => $$('[data-cart-count]').forEach((el) => { el.textContent = n; });

		/* Vuelve a pedir la sección y sustituye el tique. Devuelve el nº de artículos. */
		const refresh = async () => {
			const m = root();
			if (!m) return null;
			const res = await fetch(`${ROOT}?sections=cart-drawer`, { headers: { Accept: 'application/json' } });
			if (!res.ok) throw new Error(String(res.status));
			const html = (await res.json())['cart-drawer'];
			const fresh = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-cart-modal]');
			if (!fresh) return null;
			const oldTicket = $('[data-cart-ticket]', m);
			const newTicket = $('[data-cart-ticket]', fresh);
			if (oldTicket && newTicket) oldTicket.replaceWith(newTicket);
			const n = Number(fresh.dataset.cartCountValue || 0);
			m.dataset.cartCountValue = String(n);
			setCount(n);
			return n;
		};

		/* Cerrar: aspa, overlay, "seguir comprando" y ESC. */
		document.addEventListener('click', (e) => {
			if (!e.target.closest('[data-cart-modal] [data-cart-close]')) return;
			e.preventDefault();
			close();
		});
		document.addEventListener('keydown', (e) => { if (e.key === 'Escape') close(); });

		/* La cesta de la cabecera abre el cajón. Con modificador se deja ir a
		 * la página, igual que cuando no hay cajón en el DOM. */
		document.addEventListener('click', (e) => {
			const trigger = e.target.closest('.header__cart, [data-cart-link]');
			if (!trigger) return;
			if (e.metaKey || e.ctrlKey || e.shiftKey) return;
			const m = root();
			if (!m || m.dataset.headerOpens === 'false') return;
			e.preventDefault();
			open();
		});

		/* Quitar una línea desde el cajón sin salir de la página; si falla, el
		 * enlace navega a /cart/change como haría sin JS. */
		document.addEventListener('click', async (e) => {
			const link = e.target.closest('[data-cart-modal] [data-cart-remove]');
			if (!link) return;
			e.preventDefault();
			link.setAttribute('aria-busy', 'true');
			try {
				const res = await fetch(`${ROOT}cart/change.js`, {
					method: 'POST',
					headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
					body: JSON.stringify({ id: link.dataset.cartRemove, quantity: 0 }),
				});
				if (!res.ok) throw new Error(await res.text());
				await refresh();
			} catch {
				window.location.href = link.href;
			}
		});

		window.HighlandCart = { open, close, refresh };
		return { root, open, close, refresh };
	})();

	/* ------------------------------------------------- Añadir a la cesta */
	/* Envío por fetch para no perder el scroll; después se refresca el cajón y
	 * se abre, como el modal-tique de WP. Si el alta falla se deja que el
	 * formulario navegue como siempre; si lo que falla es el refresco, el
	 * producto ya está en la cesta y se va a la página de la cesta. */
	$$('[data-cart-add]').forEach((form) => {
		form.addEventListener('submit', async (e) => {
			e.preventDefault();
			const btn = form.querySelector('button[type="submit"]');
			if (btn) btn.disabled = true;
			let added = false;

			try {
				const res = await fetch(`${ROOT}cart/add.js`, {
					method: 'POST',
					headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
					body: JSON.stringify({
						id: Number(form.querySelector('[name="id"]').value),
						quantity: Number(form.querySelector('[name="quantity"]').value || 1),
					}),
				});
				if (!res.ok) throw new Error(await res.text());
				added = true;

				form.classList.add('is-added');
				setTimeout(() => form.classList.remove('is-added'), 1600);

				const drawer = cartDrawer.root();
				if (drawer) {
					await cartDrawer.refresh();
					if (drawer.dataset.openOnAdd !== 'false') cartDrawer.open();
				} else {
					const cart = await (await fetch(`${ROOT}cart.js`)).json();
					$$('[data-cart-count]').forEach((el) => { el.textContent = cart.item_count; });
				}
			} catch {
				if (added) window.location.href = `${ROOT}cart`;
				else form.submit();
			} finally {
				if (btn) btn.disabled = false;
			}
		});
	});

	/* ------------------------------------------------- Acordeón de FAQ */
	/* Portado tal cual de main.js: .is-open en el <li> y aria-expanded en el botón. */
	$$('[data-faq-toggle]').forEach((btn) => {
		btn.addEventListener('click', (e) => {
			e.preventDefault();
			const item = btn.closest('[data-faq-item]');
			if (!item) return;
			const willOpen = !item.classList.contains('is-open');
			item.classList.toggle('is-open', willOpen);
			btn.setAttribute('aria-expanded', String(willOpen));
		});
	});

	/* ------------------------------------------------- Configurar cookies */
	/* Reabre el banner de consentimiento de Shopify. Segun la version de la API
	 * de privacidad, el metodo esta en window.privacyBanner o en
	 * Shopify.customerPrivacy; se intentan ambos. */
	$$('[data-cookie-prefs]').forEach((btn) => {
		btn.addEventListener('click', (e) => {
			e.preventDefault();
			try {
				if (window.privacyBanner && typeof window.privacyBanner.showPreferences === 'function') {
					window.privacyBanner.showPreferences();
				} else if (window.Shopify && window.Shopify.customerPrivacy && typeof window.Shopify.customerPrivacy.openConsentManagement === 'function') {
					window.Shopify.customerPrivacy.openConsentManagement();
				} else {
					// Ultimo recurso: llevar a la pagina de cookies.
					window.location.href = '/pages/cookies';
				}
			} catch (err) {
				window.location.href = '/pages/cookies';
			}
		});
	});

})();
